import React, { useEffect, useState } from 'react';
import { Box, Card, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  CardComponent,
  ChartBarStacked,
  CostTrend,
  GeneralCardComponent,
  LineChart,
  PageTitleAndSubTitle,
  RadioButton,
  ToggleGroup,
  Warning,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import stopLossMessages from '../../core-utils/messages/stopLossTriggers';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import { useStores } from '../../stores';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import {
  formatDate,
  numberToCurrencyFormatter,
} from '../../core-utils/helper-utils/helper';
import BasicTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import {
  CostTrendChartType,
  aggregateStopLossColumns,
  coverageFieldMap,
  getAggregateReportColumns,
  specificStopLossColumns,
} from '../../core-utils/helper-utils/stopLossTriggerHelpers';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import axios from 'axios';
import properties from '../../core-utils/properties';
import noDataImg from '../../../public/Images/NoData.png';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import messages from '../../core-utils/messages';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';

export const radioLegend = (color: string, value: string) => {
  return (
    <Grid
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: '0px 24px 0px 0px',
      }}
    >
      <RadioButton color={color} checked={true} />
      <Grid>
        <Typography
          fontSize="12px"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
        >
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
};

const StopLossAggregateReport = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      marginTop: '40px',
      marginLeft: '63px',
      width: '1186px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '36px',
      marginBottom: '28px',
      gap: '24px',
    },
    currentYear: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '10px',
    },
    card: {
      width: '1186px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05);',
      borderRadius: '8px',
      background: patientAccessTheme.palette.status.white,
      border: '1px solid' + patientAccessTheme.palette.grey[300],
      padding: '24px',
    },
    scroll: scrollBarStyles,
    infoBar: {
      borderR: '4px',
      padding: '8px 16px',
      display: 'flex',
      gap: '10px',
      background: '#EDEFF4',
      alignItems: 'center',
    },
  });
  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  //State Variables -
  const [loading, setLoading] = useState<boolean>(false);
  const [isAggregateDataPresent, setIsAggregateDataPresent] = useState<boolean>(
    true,
  );
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );

  const [toggleState, setToggleState] = React.useState<'left' | 'right'>(
    'left',
  );
  const [stoplossCarriers, setStoplossCarriers] = useState<any>([]);
  const [specificStoplossData, setSpecificStoplossData] = useState<string[][]>([
    ['', ''],
  ]);
  const [aggregateStoplossData, setAggregateStoplossData] = useState<
    string[][]
  >([['', '']]);

  const [aggregateReportData, setAggregateReportData] = useState<string[][]>([
    ['', ''],
  ]);
  const [
    CostTrendChartType,
    setCostTrendChartType,
  ] = useState<CostTrendChartType>({
    attachmentPoint: [],
    rxPaidClaims: [],
    medicalPaidClaims: [],
    xAxisLabel: [],
    dataSetProp: [],
    paidClaims: [],
  });
  const [levelOfCoverage, setLevelOfCoverage] = useState<string[]>([]);

  //Stores
  // const loginPageStore = useStores().loginPageStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const employerGroupStore = useStores().employerGroupStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  // const loginPageStore = useStores().loginPageStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { open, closeModal, isEditMode } = useCohortModal();

  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const abortController = new AbortController();
  const payload = useAPIPayload();

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        stopLossMessages.report.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  // Edit duration related states and functions

  const formatSpecificStopLossData = (data: any) => {
    const specificStopLossTableData: any[][] = [];
    data?.forEach((item: any) => {
      const tempRowData = [];
      tempRowData[0] = item?.label;
      tempRowData[1] = item?.value;
      specificStopLossTableData.push(tempRowData);
    });

    setSpecificStoplossData(specificStopLossTableData);
  };

  const formatAggregateStopLossData = (data: any) => {
    const aggregateStopLossTableData: any[][] = [];
    data?.forEach((item: any) => {
      const tempRowData = [];
      tempRowData[0] = item?.label;
      tempRowData[1] = item?.value;
      aggregateStopLossTableData.push(tempRowData);
    });

    setAggregateStoplossData(aggregateStopLossTableData);
  };

  const formatAggregateReportData = (data: any, levelOfCoverage: string[]) => {
    const aggregateReportTableData: any[][] = [];
    let aggregateAttachmentSum = 0;
    let paidClaimsSubjToAggregateSum = 0;

    const numToCurrency = (value: number) => {
      return numberToCurrencyFormatter(value, true, 2);
    };

    data?.forEach((item: any) => {
      const tempRowData = [];
      tempRowData.push(
        item?.month?.toString()?.substr(0, 3) + ' - ' + item?.service_year,
      );

      levelOfCoverage.forEach((coverage) => {
        const key = coverageFieldMap[coverage];
        if (key) {
          tempRowData.push(item?.[key] ?? '');
        }
      });
      tempRowData.push(numToCurrency(item?.Monthly_Aggregate_Attachement));
      tempRowData.push(numToCurrency(item?.YTD_Attachement_Point));
      tempRowData.push(numToCurrency(item?.Monthly_medical_paid_claims));
      tempRowData.push(numToCurrency(item?.Monthly_rx_paid_claims));
      tempRowData.push(numToCurrency(item?.Monthly_paid_claims));
      tempRowData.push(numToCurrency(item?.YTD_paid_claims));
      tempRowData.push(
        numToCurrency(
          item?.Monthly_paid_claims_exceeding_specific_stop_loss ?? 0,
        ),
      );
      tempRowData.push(
        numToCurrency(item?.YTD_paid_claims_exceeding_specific_stop_loss ?? 0),
      );
      tempRowData.push(
        numToCurrency(item?.Monthly_paid_claims_outside_stop_loss ?? 0),
      );
      tempRowData.push(
        numToCurrency(item?.YTD_paid_claims_outside_stop_loss ?? 0),
      );
      tempRowData.push(
        numToCurrency(item?.Monthly_paid_claims_subj_to_aggregate),
      );
      tempRowData.push(numToCurrency(item?.YTD_paid_claims_subj_to_aggregate));
      tempRowData.push(
        typeof item?.Loss_ratio === 'number'
          ? item?.Loss_ratio?.toFixed(2) + '%'
          : item?.Loss_ratio,
      );
      aggregateReportTableData.push(tempRowData);
      aggregateAttachmentSum += item?.Monthly_Aggregate_Attachement;
      paidClaimsSubjToAggregateSum +=
        item?.Monthly_paid_claims_subj_to_aggregate;
    });

    let lastRow: any[] = [];

    lastRow.push('Total');
    levelOfCoverage.forEach(() => lastRow.push(''));
    lastRow = lastRow.concat([
      numToCurrency(aggregateAttachmentSum),
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      numToCurrency(paidClaimsSubjToAggregateSum),
      '',
      ((paidClaimsSubjToAggregateSum / aggregateAttachmentSum) * 100)?.toFixed(
        2,
      ) + '%',
    ]);
    data?.length > 0 && aggregateReportTableData?.push(lastRow);

    return aggregateReportTableData;
  };

  //API calls
  const getStoplossSummary = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.stoplossAggregateBaseUrl +
          properties.stoplossAggregateSummary,
        {
          group_id: employerGroupStore?.employerGroupResponseData?.eg_nid,
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        },
        { signal: abortController.signal },
      )
      .then(async (res) => {
        setStoplossCarriers([
          {
            title: 'Stop Loss Carrier',
            value: res?.data?.data?.stop_loss_carrier,
          },
        ]);
        formatSpecificStopLossData(res?.data?.data?.specific_stop_loss);
        formatAggregateStopLossData(res?.data?.data?.aggregate_stop_loss);
        setIsAggregateDataPresent(res?.data?.data?.aggregate_coverage ?? false);

        const levelOfCoverage = res?.data?.data?.level_of_coverage;
        const allCoverageKeys = [
          'Subscriber',
          'Subscriber and Spouse',
          'Parent and Children',
          'Family',
        ];
        const activeCoverageKeys = levelOfCoverage?.length
          ? levelOfCoverage
          : allCoverageKeys;

        setLevelOfCoverage(activeCoverageKeys);
        await getAggregateReport(activeCoverageKeys);
      });
  };

  const getPaidClaimsMontly = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.stoplossAggregateBaseUrl +
          properties.stoplossPaidClaims,
        {
          group_id: employerGroupStore?.employerGroupResponseData?.eg_nid,
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          paidClaimsFactor: 'Monthly',
        },
        { signal: abortController.signal },
      )
      .then((res: any) => {
        const data = res?.data?.data;
        const paidClaimsMontlyData = {
          paidClaims: data?.map((item: any) => ({
            value: item?.Monthly_paid_claims_subj_to_aggregate,
          })),
          attachmentPoints: data?.map((item: any) => ({
            value:
              item?.monthly_attachment_point === 0
                ? null
                : item?.monthly_attachment_point,
          })),
          expectedBudget: data?.map((item: any) => ({
            value:
              item?.monthly_attachment_point === 0
                ? null
                : item?.monthly_attachment_point / 1.25,
          })),
          categories: data?.map((item: any) => ({
            label: `${item?.month?.toString().substr(0, 3)}<br>${
              item?.plan_year
            }`,
          })),
        };
        const dataSetProp = [
          {
            seriesname: 'Monthly Paid Claims (Sbj to Aggregate)',
            plottooltext: 'Paid Claims- $$dataValue',
            data: paidClaimsMontlyData?.paidClaims,
            color: patientAccessTheme.palette.grey.A700,
            anchorBgColor: patientAccessTheme.palette.AIQChips?.legend1,
          },
          {
            seriesname: 'Expected Budget',
            plottooltext: 'Expected Budget- $$dataValue',
            data: paidClaimsMontlyData?.expectedBudget,
            color: '#FF8E59',
            renderas: 'line',
            anchorBgColor: '#FF8E59',
            connectNullData: '0',
          },
          {
            seriesname: 'Monthly Attachment Point',
            plottooltext: 'Attachment Point- $$dataValue',
            data: paidClaimsMontlyData?.attachmentPoints,
            color: '#D6545E',
            renderas: 'line',
            anchorBgColor: '#D6545E',
            connectNullData: '0',
          },
        ];
        setCostTrendChartType({
          attachmentPoint: paidClaimsMontlyData.attachmentPoints,
          paidClaims: paidClaimsMontlyData.paidClaims,
          xAxisLabel: paidClaimsMontlyData.categories,
          dataSetProp: dataSetProp,
        });
      });
  };

  const getPaidClaimsYearToDate = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.stoplossAggregateBaseUrl +
          properties.stoplossPaidClaims,
        {
          group_id: employerGroupStore?.employerGroupResponseData?.eg_nid,
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        },
        { signal: abortController.signal },
      )
      .then((res: any) => {
        const data = res?.data?.data;
        const paidClaimsCostTrendYearToDate = {
          paidClaims: data?.map((item: any) => ({
            value:
              item?.year_to_date_paid_claims === 0
                ? null
                : item?.year_to_date_paid_claims,
          })),
          attachmentPoints: data?.map((item: any) => ({
            value:
              item?.year_to_date_attachment_point === 0
                ? null
                : item?.year_to_date_attachment_point,
          })),
          categories: data?.map((item: any) => ({
            label: `${item?.month?.toString().substr(0, 3)}<br>${
              item?.plan_year
            }`,
          })),
        };
        const dataSetProp = [
          {
            seriesname: 'Year To Date (YTD) Attachment Point',
            plottooltext: 'Attachment Points - $$dataValue',
            data: paidClaimsCostTrendYearToDate?.attachmentPoints,
            color: patientAccessTheme.palette.AIQChips?.legend1,
            renderas: 'line',
            anchorBgColor: patientAccessTheme.palette.AIQChips?.legend1,
            connectNullData: '0',
          },
          {
            seriesname: 'Year To Date (YTD) Paid Claims',
            plottooltext: ' Paid Claims- $$dataValue',
            data: paidClaimsCostTrendYearToDate?.paidClaims,
            color: patientAccessTheme.palette.AIQChips?.legend2,
            renderas: 'line',
            anchorBgColor: patientAccessTheme.palette.AIQChips?.legend2,
            connectNullData: '0',
          },
        ];
        setCostTrendChartType({
          attachmentPoint: paidClaimsCostTrendYearToDate.attachmentPoints,
          paidClaims: paidClaimsCostTrendYearToDate.paidClaims,
          xAxisLabel: paidClaimsCostTrendYearToDate.categories,
          dataSetProp: dataSetProp,
        });
      });
  };

  const getAggregateReport = async (levelOfCoverage: string[]) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.stoplossAggregateBaseUrl +
          properties.stoplossAggregateReport,
        {
          group_id: employerGroupStore?.employerGroupResponseData?.eg_nid,
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        },
        { signal: abortController.signal },
      )
      .then((res: any) => {
        const data = res?.data?.data;
        setAggregateReportData(
          formatAggregateReportData(data, levelOfCoverage),
        );
      });
  };

  const apiCalls = async () => {
    setLoading(true);
    await getStoplossSummary();

    getPaidClaimsMontly();
    setLoading(false);
  };

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  useEffect(() => {
    toggleState === 'left' ? getPaidClaimsMontly() : getPaidClaimsYearToDate();
  }, [toggleState]);

  const [loader] = useState<any>(<Loader />);

  const StopLossReport = () => {
    return (
      <Grid container className={`${classes.flexContainer} ${classes.scroll}`}>
        <Card className={classes.card}>
          <GeneralCardComponent
            title={stopLossMessages.report.currentYear}
            titleColor={patientAccessTheme.palette.status.white}
            body={
              <Grid>
                {stoplossCarriers?.map((item: any) => {
                  return (
                    <Grid className={classes.currentYear}>
                      <Typography
                        fontSize="14px"
                        lineHeight="22.5px"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        fontType="semiBold"
                      >
                        {item?.title}
                      </Typography>
                      <Typography
                        fontSize="14px"
                        lineHeight="22.5px"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        fontType="semiBold"
                      >
                        {item?.value}
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            }
            titleRightMostItem={
              <Typography
                fontSize="14px"
                lineHeight="21px"
                textColor={patientAccessTheme.palette.status.white}
                fontType="semiBold"
              >
                {formatDate(
                  aggregationParameter === 'paid'
                    ? paidStartDate
                    : incurredStartDate,
                  'MMMM Do, YYYY',
                  'YYYY-MM-DD',
                ) +
                  ' to ' +
                  formatDate(
                    aggregationParameter === 'paid'
                      ? paidEndDate
                      : incurredEndDate,
                    'MMMM Do, YYYY',
                    'YYYY-MM-DD',
                  )}
              </Typography>
            }
            headerStyles={{
              backgroundColor: patientAccessTheme.palette.grey[700],
            }}
            width="100%"
          />
          <Grid
            container
            style={{ marginTop: '24px', justifyContent: 'space-between' }}
          >
            <Grid>
              <BasicTable
                width="550px"
                columns={specificStopLossColumns}
                rowsData={specificStoplossData}
                displayType={'box'}
                isColumnsHeader={true}
              />
            </Grid>
            <Grid>
              <BasicTable
                width="550px"
                columns={aggregateStopLossColumns}
                rowsData={aggregateStoplossData}
                displayType={'box'}
                isColumnsHeader={true}
              />
            </Grid>
          </Grid>
        </Card>
        <CostTrend
          chartTitle={stopLossMessages.report.lineChartTitle}
          chartSubTitle={stopLossMessages.report.lineChartSubTitle}
          showClickHere={false}
          datasetProp={CostTrendChartType.dataSetProp}
          xAxisValues={CostTrendChartType.xAxisLabel}
          customYAxisTitle={
            <Grid style={{ position: 'absolute', top: '80px', left: '10px' }}>
              <Typography
                fontSize="12px"
                lineHeight="23px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
              >
                Cost($)
              </Typography>
            </Grid>
          }
          chartType={
            toggleState === 'left' ? 'stackedcolumn2dlinedy' : 'msline'
          }
          showLegend="0"
          customLegend={
            <Grid
              container
              style={{
                position: 'absolute',
                bottom: '0px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {CostTrendChartType.dataSetProp.map((item: any) =>
                radioLegend(item?.color, item?.seriesname),
              )}
            </Grid>
          }
          yAxisTitle=""
          cardWidth="1186px"
          cardHeight="400px"
          chartWidth="1130"
          spaceBetweenTitleAndChart="30px"
          topRightItem={
            <ToggleGroup
              leftValue={'Monthly'}
              rightValue={'Aggreggate'}
              leftIcon={
                <ChartBarStacked
                  stroke={
                    toggleState === 'left'
                      ? patientAccessTheme.palette.primary[500]
                      : patientAccessTheme.palette.status.icon
                  }
                  style={{ height: '16px', width: '16px' }}
                />
              }
              rightIcon={
                <LineChart
                  fill={
                    toggleState === 'right'
                      ? patientAccessTheme.palette.primary[500]
                      : patientAccessTheme.palette.status.icon
                  }
                  style={{ height: '16px', width: '16px' }}
                />
              }
              setSelectedToggle={setToggleState}
            />
          }
        />
        <CardComponent
          title={stopLossMessages.report.aggregateReportTitle}
          subTitle={stopLossMessages.report.aggreateReportSubTitle}
          width="1186px"
          body={
            <Grid style={{ overflowX: 'scroll' }} className={classes.scroll}>
              <BasicTable
                width="2250px"
                columns={getAggregateReportColumns(levelOfCoverage)}
                rowsData={aggregateReportData}
                displayType={'box'}
              />
            </Grid>
          }
        ></CardComponent>
      </Grid>
    );
  };

  const NoDataVisual = () => {
    return (
      <Grid style={{ height: '500px', display: 'flex' }}>
        <GifWithLabels
          mainLabel={
            <Grid className={classes.infoBar}>
              <Typography
                fontSize="14px"
                lineHeight="22.4px"
                textColor={patientAccessTheme.palette.text.lowemphasis}
                fontType="medium"
              >
                {messages.NO_AGGREGATE_DATA}
              </Typography>
              <Warning />
            </Grid>
          }
          subLabel={''}
          gifUrl={noDataImg}
        />
      </Grid>
    );
  };

  return isPlanDatesLoading || loading || isInitializing ? (
    loader
  ) : (
    <Box className={classes.mainDiv}>
      <Box style={{ width: '1186px' }}>
        <PageTitleAndSubTitle
          title={stopLossMessages.report.title}
          subTitle={stopLossMessages.report.subTitle}
          showDownloadButton={isAggregateDataPresent}
          // downloadButtonAction={() => setOpenReportsModal(true)}
          downloadButtonAction={() => {
            downloadPdf(
              'stoplossAggregateReport',
              {
                employer:
                  employerGroupStore?.employerGroupResponseData
                    ?.employer_group_name,
                member_unique_id_list: [],
                claim_id_list: [],
                maxClaimDate:
                  employerGroupStore?.employerGroupResponseData?.max_claim_date,
                ...payload,
              },
              handleOpenSnackBar,
              'open',
            );
            handleOpenSnackBar(
              snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
              'info',
              6000,
            );
          }}
          // showQueryDataButton={checkUserAccess(
          //   UserAccessConstants.COHORT_DETAILS,
          //   loginPageStore.userResponse.role.name,
          //   loginPageStore.userFeatures,
          // )}
          // queryButtonText={
          //   cohortDetailsStore.cohortDetailsList?.length > 0 &&
          //   cohortDetailsStore.cohortDetailsList[0].category !== ''
          //     ? 'Edit Cohort'
          //     : 'Add Cohort'
          // }
          // queryDataAction={() => {
          //   if (
          //     checkUserAccess(
          //       UserAccessConstants.COHORT_DETAILS,
          //       loginPageStore.userResponse.role.name,
          //       loginPageStore.userFeatures,
          //     )
          //   ) {
          //     openModal();
          //   }
          // }}
        />
        <div
          style={{
            position: 'relative',
            top: '-59px',
            left: '245px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography
            fontSize="17px"
            lineHeight="21px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontType="semiBold"
            margin="0px 8px"
          >
            for
          </Typography>
          <DateFilter />
        </div>
        <TabSelection
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={handleSelectedIndex}
          recommendationFetched={recommendationFetched}
          margin="0px"
        />
        <CohortFilterBar />
      </Box>
      {selectedTabIndex === 0 && (
        <>{isAggregateDataPresent ? <StopLossReport /> : <NoDataVisual />}</>
      )}
      {selectedTabIndex === 1 && (
        <div style={{ height: '493px', padding: '20px' }}>
          <RecommendationsTab
            recommendationLoading={recommendationLoading}
            isInternalPage={true}
          />
        </div>
      )}
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
    </Box>
  );
});

export default StopLossAggregateReport;
